import React, { useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import StartPage from "./pages/StartPage";
import { LoginErrorRecoveryPage } from "./pages/LoginErrorRecoveryPage";
import { Dashboard } from "./pages/Dashboard";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import Setup from "./pages/Setup";
import RegistrationSetup from "./pages/RegistrationSetup";
import Login from "./pages/Login";
import { LoadingData } from "./pages/LoadingData";
import "react-toastify/dist/ReactToastify.css";
import { Slide, ToastContainer } from "react-toastify";

import { Introduction as SetupDataIntroduction } from "./pages/setupdata/Introduction";
import { YourDetails as SetupDataYourDetails } from "./pages/setupdata/YourDetails";
import { YourControl as SetupDataYourControl } from "./pages/setupdata/YourControl";
import Consent from "./pages/setupdata/Consent";
import { SmokingHistory } from "./pages/setupdata/SmokingHistory";
// import InitialExperience from "./pages/setupdata/InitialExperience";
import AsbestosHistory from "./pages/setupdata/AsbestosHistory";
import BenefitStatus from "./pages/setupdata/BenefitStatus";
import { Questionnaire } from "./components/Questionnaire";
import { MultiQuestionnaire } from "./components/MultiQuestionnaire";
import { ErrorBoundaryWithRouter } from "./pages/ErrorBoundary";
import { toastConfig } from "./configs/toastConfig";
import { LongTermConditions } from "./pages/setupdata/LongTermConditions";
import { DiseaseGroupContext, themes } from "./contexts/diseaseGroupContext";
import { DashboardContextProvider } from "./contexts/dashboardContext";
import { getDiseaseGroup } from "./services/userService";
import Compensation from "./pages/setupdata/Compensation";
import { XCircle } from "./components/common/IconsV2";
import { getIsLoggedIn } from "./services/userService";

class AppContextWrapper extends React.Component {
	constructor(props) {
		super(props);

		this.setTheme = (themeName) => {
			this.setState({
				theme: themes.getTheme(themeName),
			});
		};

		const diseaseGroup = getDiseaseGroup();
		let theme;
		if (diseaseGroup) {
			theme = themes.getTheme(diseaseGroup);
		} else {
			theme = themes.default();
		}

		this.state = {
			theme: theme,
			setTheme: this.setTheme,
		};
	}

	render() {
		return (
			<DiseaseGroupContext.Provider value={this.state}>
				{this.props.children}
			</DiseaseGroupContext.Provider>
		);
	}
}

function App() {
	const { instance, accounts } = useMsal();
	const b2cAuthenticated = useIsAuthenticated();
	const [autoAuthenticated, setAutoAuthenticated] = useState(getIsLoggedIn());

	const forceAutoAuthenticate = () => {
		setAutoAuthenticated(true);
	};

	return (
		<>
			<AppContextWrapper>
				{(b2cAuthenticated || autoAuthenticated) && (
					<ErrorBoundaryWithRouter goToPath={"/error"}>
						<Switch>
							<Route path="/dashboard">
								<DashboardContextProvider>
									<Dashboard />
								</DashboardContextProvider>
							</Route>
							<Route path="/setupdata/introduction">
								<SetupDataIntroduction />
							</Route>
							<Route path="/setupdata/yourcontrol">
								<SetupDataYourControl />
							</Route>
							<Route path="/setupdata/consent">
								<Consent />
							</Route>
							<Route path="/setupdata/yourdetails">
								<SetupDataYourDetails />
							</Route>
							<Route path="/setupdata/smokinghistory">
								<SmokingHistory />
							</Route>
							{/* <Route path="/setupdata/initialexperience">
								<InitialExperience />
							</Route> */}
							<Route path="/setupdata/asbestoshistory">
								<AsbestosHistory />
							</Route>
							<Route path="/setupdata/benefitstatus">
								<BenefitStatus />
							</Route>
							<Route path="/setupdata/longtermconditions">
								<LongTermConditions />
							</Route>
							<Route path="/setupdata/compensation">
								<Compensation />
							</Route>
							<Route path="/questionnaire/:id" children={<Questionnaire />} />
							<Route path="/questionnaire">
								<Questionnaire />
							</Route>
							<Route path="/multiquestionnaire">
								<MultiQuestionnaire />
							</Route>
							<Route path="/setup" render={(props) => <Setup {...props} />} />
							<Route
								path="/loadingdata"
								render={(props) => <LoadingData {...props} />}
							/>
							<Route path="/error">
								<LoginErrorRecoveryPage />
							</Route>
							<Route exact path="/">
								<Login msalInstance={instance} msalAccount={accounts[0]} />
							</Route>
							<Redirect to={"/error"} />
						</Switch>
					</ErrorBoundaryWithRouter>
				)}
				{!(b2cAuthenticated || autoAuthenticated) && (
					<>
						<Route path="/">
							<StartPage forceRefresh={forceAutoAuthenticate} />
						</Route>
						<Route
							path="/registrationsetup"
							render={(props) => <RegistrationSetup {...props} />}
						/>
					</>
				)}
				<ToastContainer
					limit={3}
					theme="light"
					hideProgressBar={true}
					position={toastConfig.position}
					transition={Slide}
					className={
						"p-safeAreaBottomToast text-center text-black border-1 rounded border-gray-400 shadow-top bg-white"
					}
					toastClassName={"bg-white m-0"}
					bodyClassName={`text-black`}
					autoClose={10 * 1000}
					closeButton={
						<div>
							<XCircle className={`text-red-600 w-5`} />
						</div>
					}
					enableMultiContainer={true}
				/>
			</AppContextWrapper>
		</>
	);
}

export default App;
